import { cloneDeepWith, cloneDeep } from "lodash";
import { isMdaeWidgetOptionChangeEvent, updateStateAfterWidgetOptionChange } from "../../mdae-framework";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";
import { GET_DOCUMENT_OCR_STATUS } from "../services/get-document-ocr-status";
import { getCaseSearchCriteriaMappings } from "../constants";
import { convertDate, convertDateFormat } from "../../../utils/dateUtils";
import applyChanges from 'devextreme/data/apply_changes';
import Guid from "devextreme/core/guid";
import { SET_EA_CASE_LIST_DATA } from "../../../pages/external-audit/case-list/reducers/case-list-reducer";
import { toggleCaseSearchListPopupVisible } from "../case-search-common-functions";
import { SET_EXTERNAL_AUDIT_SELECTED_INDEX } from "../../../pages/external-audit/reducers/external-audit-reducer";
import mdaeNotify, { NOTIFY_MESSAGE_TYPE } from "../../common_widgets/toast/notify";
import { TOGGLE_NOTIFY_POPUP } from "../../mdae-common-reducer";
import { NOTIFY_POPUP_TYPES } from "../../common_widgets/notify-popup";
import React from "react";
import { SET_AUDIT_PROPERTIES_DATA } from "../../../pages/external-audit/reducers/audit-properties-reducer";

export const SET_ACCOUNT_CASE_SEARCH_DATA = "SET_ACCOUNT_CASE_SEARCH_DATA";
export const SET_ACCOUNT_NUMBER_LIST_INPUT_WIDGET = "SET_ACCOUNT_NUMBER_LIST_INPUT_WIDGET";
export const SET_ACCOUNT_NUMBERS_CASE_SEARCH_DATA = "SET_ACCOUNT_NUMBERS_CASE_SEARCH_DATA";
export const SET_CASE_SEARCH_LIST_DATA = "SET_CASE_SEARCH_LIST_DATA";
export const TOGGLE_CASE_SEARCH_LIST_POPUP = "TOGGLE_CASE_SEARCH_LIST_POPUP";
export const SET_CASE_LIST_GRID_SELECTED_ROW_KEYS = "SET_CASE_LIST_GRID_SELECTED_ROW_KEYS";
export const SET_KEY_INFORMATION_CASE_SEARCH_DATA = "SET_KEY_INFORMATION_CASE_SEARCH_DATA";
export const START_OCR_STATUS_POOLING = "START_OCR_STATUS_POOLING";
export const RESET_OCR_STATUS = "RESET_OCR_STATUS";
export const RESET_AUTOCOMPLETE_DATA = "RESET_AUTOCOMPLETE_DATA";
export const SAVE_CASE_SEARCH_CRITERIA_DATAGRID_CHNAGES = "SAVE_CASE_SEARCH_CRITERIA_DATAGRID_CHNAGES";
export const ADD_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST = "ADD_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST";
export const REMOVE_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST = "REMOVE_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST";
export const CLEAR_SELECTED_CASE_DETAIL_IDS_TO_ADD_TO_AUDIT = "CLEAR_SELECTED_CASE_DETAIL_IDS_TO_ADD_TO_AUDIT";
export const DELETE_CASE_SEARCH_CRITERIA_BY_IDS = "DELETE_CASE_SEARCH_CRITERIA_BY_IDS";
export const caseSearchCriteriaDatagridKeyExpr = "caseSearchCriteriaGUID";
export const TOGGLE_OCR_FEEDBACK_POPUP = "TOGGLE_OCR_FEEDBACK_POPUP";
export const SET_S3_OBJECT_NAME = "SET_S3_OBJECT_NAME";
export const SET_FEEDBACK_SECTION_VALUES = "SET_FEEDBACK_SECTION_VALUES"
export const SET_CASE_SEARCH_DOCUMENT_DATA = "SET_CASE_SEARCH_DOCUMENT_DATA";
export const CASE_SEARCH_CLICKED = "CASE_SEARCH_CLICKED";
  export const accountCaseSearchData = {
    claimTypeCd: null,
    caseSearchParams: []
  }

  export const keyInformationCaseSearchData = {
    claimTypeCd: null,
    keyInfoDownloadTemplateColumns: [],
    keyInformationCaseSearchFileData: [],
    keyInformationInvalidCaseSearchData: []
  }
  export const ocrPollingData = {
    s3ObjectName: "",
  };
  export const ocrDocumentData = {
    documentId: -1,
    pdfPageCount: -1,
  };
  export interface OCRJobStatus {
    filename: string;
    bucket: string;
    run_status: string;
    complete_percentage: number;
    current_step: string;
    start_time?: Date;
    end_time?: Date;
    result_json: string;
    autocomplete_result_json: string;
    trigger_value:string;
    reviewer:{
      reviewerIdentifierText: string;
      reviewerName: string;
    };
  }
  export const initialOCRJobStatus: OCRJobStatus = {
    filename: '',
    bucket: '',
    run_status: '',
    complete_percentage: 0,
    current_step: '',
    start_time: new Date(),
    end_time: new Date(),
    result_json: null,
    autocomplete_result_json: null,
    trigger_value: null,
    reviewer: null
  }
  export const DOS_SEARCH_TYPES = {
    SINGLE_DOS: "SINGLE_DOS",
    DOS_RANGE: "DOS_RANGE",
  };
  export const DOS_SEARCH_TYPE_DETAILS = [
    { displayAlias: "Search Claims(s) By DOS", value: DOS_SEARCH_TYPES.SINGLE_DOS },
    {
      displayAlias: "Search All Claims in Service Range",
      value: DOS_SEARCH_TYPES.DOS_RANGE,
    },
  ];
  const initialKeyInformationCaseSearchData: {
    [key: string]: any;
    dosSearchType: "SINGLE_DOS" | "DOS_RANGE",
  } = {
    dosSearchType: "SINGLE_DOS"
  };

  const initialState = {
    accountCaseSearchData: null,
    caseFoundList: [],
    caseNotFoundList: [],
    isTextBoxWidgetVisible: false,
    caseSearchAccountNumbers: null,
    caseListGridSelectedRowKeys: [],
    keyInformationCaseSearchData: initialKeyInformationCaseSearchData,
    ocrPollingData,
    ocrDocumentData,
    ocrJobStatus: initialOCRJobStatus,
    caseSearchListPopupVisibleInd: false,
    caseSearchCriteriaList: [],
    autocompleteData: [],
    selectedCaseDetailIdsToAddToAudit: [],
    caseSearchClickedInd:false,

  }

  const CaseSearchReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
      case asyncTypes.OPERATION:
      case asyncTypes.COMPLETE:
      case asyncTypes.FAILURE:
        if (isAsyncComplete(GET_DOCUMENT_OCR_STATUS)(action)) {
          const ocrResponseObject = convertResponseToOCRJobStatus(
            action.response
          );
          const caseSearchCriteriaList = ocrResponseObject.result_json
            ? convertAndFormatOCRJSONToCaseSearchCriteriaArray(
                ocrResponseObject.result_json,
                state.keyInformationCaseSearchData.claimTypeCd
              )
            : [];
          const autocompleteData = JSON.parse(
            ocrResponseObject?.autocomplete_result_json || `[]`
          );
          return {
            ...state,
            ocrJobStatus: { ...ocrResponseObject },
            caseSearchCriteriaList,
            autocompleteData,
          };
        }
        return state;
      case SET_ACCOUNT_CASE_SEARCH_DATA:
        newState = cloneDeepWith(state);
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState = updateStateAfterWidgetOptionChange(newState, action.data);
        } else {
          const accountCaseSearchData = newState.accountCaseSearchData
            ? newState.accountCaseSearchData
            : {};
          for (let prop in action.data.accountCaseSearchData) {
            accountCaseSearchData[prop] =
              action.data.accountCaseSearchData[prop];
          }
          newState = {
            ...newState,
            accountCaseSearchData: accountCaseSearchData,
          };
        }
        return newState;
      case SET_ACCOUNT_NUMBER_LIST_INPUT_WIDGET:
      case SET_ACCOUNT_NUMBERS_CASE_SEARCH_DATA:
      case SET_CASE_SEARCH_LIST_DATA:
      case SET_CASE_LIST_GRID_SELECTED_ROW_KEYS:
        newState = cloneDeepWith(state);
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState = updateStateAfterWidgetOptionChange(newState, action.data);
        } else {
          newState = { ...newState, ...action.data };
        }
        return newState;
      case SET_KEY_INFORMATION_CASE_SEARCH_DATA:
        newState = cloneDeepWith(state);
        if (isMdaeWidgetOptionChangeEvent(action.data)) {
          newState = updateStateAfterWidgetOptionChange(newState, action.data);
        } else {
          const keyInformationCaseSearchData = newState.keyInformationCaseSearchData
            ? newState.keyInformationCaseSearchData
            : {};
          for (let prop in action.data.keyInformationCaseSearchData) {
            keyInformationCaseSearchData[prop] =
              action.data.keyInformationCaseSearchData[prop];
          }
          newState = {
            ...newState,
            keyInformationCaseSearchData: keyInformationCaseSearchData,
          };
        }
        return newState;
      case START_OCR_STATUS_POOLING:
      case TOGGLE_CASE_SEARCH_LIST_POPUP:
      case SET_CASE_SEARCH_DOCUMENT_DATA:
      case CASE_SEARCH_CLICKED:
        return { ...state, ...action.data };
      case RESET_OCR_STATUS:
        return {
          ...state,
          ocrJobStatus: { ...state.ocrJobStatus, run_status: null },
        };
      case RESET_AUTOCOMPLETE_DATA:
        return {
          ...state,
          autocompleteData: [],
        };
      case SAVE_CASE_SEARCH_CRITERIA_DATAGRID_CHNAGES:
        let newData = applyChanges(
          state.caseSearchCriteriaList,
          [action.data.change],
          {
            keyExpr: caseSearchCriteriaDatagridKeyExpr,
          }
        );
        return {
          ...state,
          caseSearchCriteriaList: newData,
        };
      case DELETE_CASE_SEARCH_CRITERIA_BY_IDS:
        const caseSearchCriteriaList = state.caseSearchCriteriaList.filter(
          (x) =>
            !(action.data as string[]).includes(
              x[caseSearchCriteriaDatagridKeyExpr]
            )
        );
        const caseDetailIdsToDelete = caseSearchCriteriaList.map(
          (x) => x.caseDetailId
        );
        return {
          ...state,
          caseSearchCriteriaList,
          selectedCaseDetailIdsToAddToAudit: state.selectedCaseDetailIdsToAddToAudit.filter(
            (x) => caseDetailIdsToDelete.includes(x)
          ),
        };
      case ADD_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST:
        return {
          ...state,
          //using set makes sure we have distinct ids
          selectedCaseDetailIdsToAddToAudit: Array.from(
            new Set([
              ...state.selectedCaseDetailIdsToAddToAudit,
              ...action.data,
            ])
          ),
        };
      case REMOVE_SELECTED_IDS_TO_ADD_TO_AUDIT_LIST:
        let selectedCaseDetailIdsToAddToAudit = cloneDeep(
          state.selectedCaseDetailIdsToAddToAudit
        );
        selectedCaseDetailIdsToAddToAudit = selectedCaseDetailIdsToAddToAudit.filter(
          (x) => !(action.data as number[]).includes(x)
        );
        return {
          ...state,
          selectedCaseDetailIdsToAddToAudit,
        };
      case CLEAR_SELECTED_CASE_DETAIL_IDS_TO_ADD_TO_AUDIT:
        return {
          ...state,
          selectedCaseDetailIdsToAddToAudit: [],
        };
      case TOGGLE_OCR_FEEDBACK_POPUP:
        return {
          ...state,
          ...action.data,
        };
      case SET_FEEDBACK_SECTION_VALUES:
        return {
          ...state,
          ...action.data,
        };
      case SET_S3_OBJECT_NAME:
        return {
          ...state,
          ocrPollingData: {
            ...state.ocrPollingData,
            s3ObjectName: action.data,
          },
        };
      default:
        return state;
    }
  }

  const convertResponseToOCRJobStatus = (response): OCRJobStatus => {
    const ocrItem = response.item;
    if (Object.keys(ocrItem).length) {
      return {
        filename: ocrItem.filename.s,
        bucket: ocrItem.bucket.s,
        run_status: ocrItem.run_status.s,
        current_step: ocrItem.current_step.s,
        complete_percentage: ocrItem.complete_percentage ? parseInt(ocrItem.complete_percentage.n): 0,
        start_time:
          ocrItem.start_time && ocrItem.start_time.n
            ? new Date(ocrItem.start_time.n * 1000)
            : undefined,
        end_time:
          ocrItem.end_time && ocrItem.end_time.n
            ? new Date(ocrItem.end_time.n * 1000)
            : undefined,
        result_json:
          ocrItem.result_json && ocrItem.result_json.s
            ? ocrItem.result_json.s
            : undefined,
        autocomplete_result_json:
          ocrItem.autocomplete_result_json && ocrItem.autocomplete_result_json.s
            ? ocrItem.autocomplete_result_json.s
            : undefined,
        trigger_value:ocrItem.trigger_value && ocrItem.trigger_value.s
        ? ocrItem.trigger_value.s
        : undefined,
        reviewer:ocrItem.reviewer && JSON.parse(ocrItem.reviewer.s)
        ? JSON.parse(ocrItem.reviewer.s)
        : undefined,
      } as OCRJobStatus;
    } else return initialOCRJobStatus;
  };

  const formatCaseSearchCriteriaItem = (
    ocrResultToCaseSearchTitlesMatching,
    caseSearchCriteria,
    caseSearchCriteriaItemKey: string,
    caseSearchCriteriaItemValue: string
  ) => {
    if (caseSearchCriteriaItemValue) {
      switch (caseSearchCriteriaItemKey) {
        case ocrResultToCaseSearchTitlesMatching.discharge_date.keyExpr:
        case ocrResultToCaseSearchTitlesMatching.dos.keyExpr:
        case ocrResultToCaseSearchTitlesMatching.dob.keyExpr:
          caseSearchCriteria[caseSearchCriteriaItemKey] = new Date(
            caseSearchCriteriaItemValue as string
          );
          break;
      }
    }
  };
  export const createdOn = "createdOn";
  export const updatedOn = "updatedOn";
  export const sortOrder = "sortOrder";

  export const addCommonProperties = (object: any, order) => {
    if(!object[caseSearchCriteriaDatagridKeyExpr])
      object[caseSearchCriteriaDatagridKeyExpr] = new Guid().toString();
    object["createdOn"] = new Date();
    object["updatedOn"] = new Date();
    if(order) object["sortOrder"] = order;
  };
  export const convertAndFormatOCRJSONToCaseSearchCriteriaArray = (
    ocrObjectArrayJson,
    claimType
  ): any[] => {
    const extractedDataList = JSON.parse(ocrObjectArrayJson);
    const convertedArray = [];
    const {
      caseSearchCriteriaFiedMapperObject: ocrResultToCaseSearchTitlesMatching,
    } = getCaseSearchCriteriaMappings(claimType);

    for(let i = extractedDataList?.length - 1; i >= 0; i--){
      const dataItem = extractedDataList[i];
      const convertedData = {};
      for (const [oldKey, newKey] of Object.entries(
        ocrResultToCaseSearchTitlesMatching
      )) {
        if (!convertedData[newKey.keyExpr]) {
          //convert
          convertedData[newKey.keyExpr] = dataItem[oldKey];

          //format
          formatCaseSearchCriteriaItem(
            ocrResultToCaseSearchTitlesMatching,
            convertedData,
            newKey.keyExpr,
            dataItem[oldKey]
          );
        }
      }
      addCommonProperties(convertedData, i + 1);
      convertedArray.push(convertedData);
    }

    return convertedArray;
  };

  export const formatCaseSearchCriteriaListForGrid = (
    caseSearchCriteriaList: any[]
  ): any[] => {
    const caseSearchCriteriaListCopy = cloneDeep(caseSearchCriteriaList);
    for(let i = caseSearchCriteriaListCopy?.length - 1; i >= 0; i--){
      const dataItem = caseSearchCriteriaListCopy[i]
      if (!dataItem[caseSearchCriteriaDatagridKeyExpr])
        addCommonProperties(dataItem, i + 1);
    }
    return caseSearchCriteriaListCopy;
  };

  export const formatCaseSearchCriteriaList = (
    caseSearchCriteriaList: any[]
  ) => {
    const caseSearchCriteriaListCopy = cloneDeep(caseSearchCriteriaList);
    caseSearchCriteriaListCopy.forEach((caseSearchCriteriaItem) => {
      for (let [key, value] of Object.entries(caseSearchCriteriaItem)) {
        if (value && value instanceof Date) {
          caseSearchCriteriaItem[key] = !isNaN(value?.getTime())
            ? convertDateFormat(value, "MM/DD/YYYY")
            : null;
        }
      }
    });
    return caseSearchCriteriaListCopy;
  };


  export const addSelectedCasesToAudit = (
    selectedCases,
    caseSearchCriteriaList = [],
  ) => (dispatch, getState) => {

    var state = getState();
    const auditPropertiesData = state.auditPropertiesReducer.auditPropertiesData;
    const eaCaseListData = state.caseListReducer.eaCaseListData;
    const templateType = state.caseSearchReducer.keyInformationCaseSearchData.templateType;

    let eaCaseList = [];
    if (selectedCases.length > 0) {
      const {
        caseSearchCriteriaFiedMapperObject,
      } = getCaseSearchCriteriaMappings(
        selectedCases[0].claimTypeCode?.toUpperCase(),
        auditPropertiesData.eaAuditType
      );
      for (let i = 0; i < selectedCases.length; i++) {
        let caseData = selectedCases[i];
        const caseSearchCriteriaIdForCurCase =
          selectedCases[i][caseSearchCriteriaDatagridKeyExpr];
        let caseSearchCriteriaForCurCase = null;
        if (caseSearchCriteriaList?.length > 0)
          caseSearchCriteriaForCurCase = caseSearchCriteriaList.find(
            (x) =>
              x[caseSearchCriteriaDatagridKeyExpr] ===
              caseSearchCriteriaIdForCurCase
          );
        eaCaseList.push({
          eaCaseId: 0,
          eaAuditId: auditPropertiesData.eaAuditId,
          caseId: caseData.caseId,
          caseDetailId: caseData.caseDetailId,
          patientFullName: caseData.participantName,
          patientAcctNo: caseData.patientAcctNo,
          patientMRN: caseData.patientMRN,
          fromServiceDate: convertDate(caseData.statementFromDate),
          toServiceDate: convertDate(caseData.statementToDate),
          provider: caseData.providerName,
          caseStatusCd: "New",
          claimType:
            caseData.claimTypeCode == "I" ? "Hospital" : "Professional",
          typeOfFacilityCd: caseData.facilityName,
          payerCaseId:
            caseSearchCriteriaForCurCase !== null
              ? caseSearchCriteriaForCurCase[
                  caseSearchCriteriaFiedMapperObject.claim_id.keyExpr
                ]
              : null,
          atRiskAmtString:
            caseSearchCriteriaForCurCase !== null
              ? caseSearchCriteriaForCurCase[
                  caseSearchCriteriaFiedMapperObject.retained_amount.keyExpr
                ]
              : null,
          retainedAmount:
            caseSearchCriteriaForCurCase !== null
            ? caseSearchCriteriaForCurCase[
                caseSearchCriteriaFiedMapperObject.retained_amount.keyExpr
              ]
            : null,
        });
      }
      eaCaseList.forEach((element) => {
        eaCaseListData[0].caseList.push(element);
      });
      dispatch({
        type: SET_EA_CASE_LIST_DATA,
        data: {
          eaCaseListData: eaCaseListData,
          showCaseChangesInformation: true,
        },
      });
      if(templateType){
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
              loadType: templateType,
            },
          },
        });
      }

      toggleCaseSearchListPopupVisible(dispatch, false);
      dispatch({
        type: SET_EXTERNAL_AUDIT_SELECTED_INDEX,
        data: {
          externalAuditSelectedIndex: 4,
        },
      });
      mdaeNotify({
        message: `${selectedCases?.length} Case(s) have been added to the audit.`,
        messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
      });
      dispatch({
        type: DELETE_CASE_SEARCH_CRITERIA_BY_IDS,
        data: Array.from(
          new Set(
            selectedCases.map((x) => x[caseSearchCriteriaDatagridKeyExpr])
          )
        ),
      });
    } else {
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          visible: true,
          contentHtml: () => {
            return <div>There are no selected cases to add.</div>;
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
          closeButtonText: "OK",
          width: 470,
          height: 250,
        },
      });
    }
  };


  export default CaseSearchReducer;